module.exports = __webpack_public_path__ + "img/login.0fe2134a.png";